import useModuleTranslation from "../infra-no-ui/translation/useModuleTranslation";
import React from "react";

/**
 * Dynamically load translation files pertaining to the candidates module.
 * @return {*}
 */
export default function useTranslationChatGpt() {

  // Imports must be memoized so that they don't change on every render
  const imports = React.useMemo(() => ({
    'en': import('./locales/en/chatgpt.json'),
    'fr': import('./locales/fr/chatgpt.json')
  }), []);

  return useModuleTranslation('chatgpt', imports);
}
